import {create} from 'zustand';
import {immer} from 'zustand/middleware/immer';
import {AvatarInterface, blankAvatar} from '../hooks/useCreateAvatar';

interface UIState {
    designActive: boolean;
    setDesignActive: (active: boolean) => void;

    draftAvatar: AvatarInterface;
    setDraftAvatar: (avatar: AvatarInterface) => void;

    initialNetworkMade: boolean;
    setInitialNetworkMade: (made: boolean) => void;
}

export const uiStore = create<UIState>()(
    immer((set) => ({
        designActive: false,
        setDesignActive: (active) => {
            set((state) => {
                state.designActive = active;
            });
        },

        draftAvatar: blankAvatar,
        setDraftAvatar: (avatar) => {
            set((state) => {
                state.draftAvatar = avatar;
            });
        },

        initialNetworkMade: false,
        setInitialNetworkMade: (made) => {
            set((state) => {
                state.initialNetworkMade = made;
            });
        },
    })),
);

// ------------------- selector hooks -------------------
export const useDesignActive = () => uiStore((s) => s.designActive);
export const useSetDesignActive = () => uiStore((s) => s.setDesignActive);

export const useDraftAvatar = () => uiStore((s) => s.draftAvatar);
export const useSetDraftAvatar = () => uiStore((s) => s.setDraftAvatar);

export const useInitialNetworkMade = () => uiStore((s) => s.initialNetworkMade);
export const useSetInitialNetworkMade = () => uiStore((s) => s.setInitialNetworkMade);
